import styled from 'styled-components'
import { Row } from 'antd'
import { PropsWithChildren } from 'react'

interface RowProps {
  height?: string
  width?: string
}

const ContainerRow = styled(Row)<RowProps>`
  background-color: ${({ theme }) => theme.colors.new.baseColor[850]};
  border-radius: ${({ theme }) => theme.foundation.borderRadius};
  height: ${({ height = '300px' }) => height};
  width: ${({ width = '288px' }) => width};
  padding: 24px;
`

type PropsWithChildrenAndRow = PropsWithChildren<RowProps>

export const Card: React.FC<PropsWithChildrenAndRow> = ({ children, height, width }) => {
  return (
    <ContainerRow gutter={10} height={height} width={width}>
      {children}
    </ContainerRow>
  )
}
